<div class="project-specifications">
  <div class="project-specifications__content">
    <form [formGroup]="form" appDirtyCheck>
        <div class="project-specifications__columns">
          <div class="project-specifications__column">
            <h2 class="mat-body-large">
              {{ "Auftragsdetails" | translate: "paragraph-order-details" }}
            </h2>

            <mat-form-field class="project-specifications__field">
              <mat-label>{{ "Auftraggeber" | translate: "input-customer" }}</mat-label>
              <input type="text" matInput formControlName="contractee" />
              @if(form.controls.contractee.hasError(FORM_FIELD_ERRORS.required)){
              <mat-error>
                {{"Pflichtfelder müssen ausgefüllt werden." | translate :
                "input-error-required-fields"}}
              </mat-error>
              }
            </mat-form-field>

            <mat-form-field matAutocompleteOrigin #allocationTypeField="matAutocompleteOrigin" class="project-specifications__field">
              <mat-label>{{ "Vergabeart" | translate: "input-order-model" }}</mat-label>
              <app-base-select
                formControlName="allocationType"
                [connectedFormField]="allocationTypeField"
                [getItems]="getProjectAllocationTypes"
                valueField="localizedName"
                identifierField="number"
              />
            </mat-form-field>

            <mat-form-field matAutocompleteOrigin #clientTypeCategoryField="matAutocompleteOrigin" class="project-specifications__field">
              <mat-label>{{ "Auftraggeber-Klasse" | translate: "input-client-type-category" }}</mat-label>
              <app-base-select
                formControlName="clientTypeCategory"
                [connectedFormField]="clientTypeCategoryField"
                [getItems]="getProjectClientTypeCategories"
                valueField="localizedName"
                identifierField="number"
              />
            </mat-form-field>

            <mat-form-field matAutocompleteOrigin #clientTypeModelField="matAutocompleteOrigin" class="project-specifications__field">
              <mat-label>{{ "Auftragsmodell" | translate: "input-client-type-model" }}</mat-label>
              <app-base-select
                formControlName="clientTypeModel"
                [connectedFormField]="clientTypeModelField"
                [getItems]="getProjectClientTypeModels"
                valueField="localizedName"
                identifierField="number"
              />
            </mat-form-field>

            <mat-form-field matAutocompleteOrigin #clientTypeField="matAutocompleteOrigin" class="project-specifications__field">
              <mat-label>{{ "Auftraggeber Branche" | translate: "input-client-type" }}</mat-label>
              <app-base-select
                formControlName="clientType"
                [connectedFormField]="clientTypeField"
                [getItems]="getProjectClientTypes"
                valueField="localizedName"
                identifierField="number"
              />
            </mat-form-field>
          </div>

          <div class="project-specifications__column">
            <h2 class="mat-body-large">
              {{ "Projektdetails" | translate: "paragraph-project-details" }}
            </h2>

            <mat-form-field matAutocompleteOrigin #scopeField="matAutocompleteOrigin" class="project-specifications__field">
              <mat-label>{{ "Projektumfang" | translate: "input-project-scope" }}</mat-label>
              <app-base-select
                formControlName="scope"
                [connectedFormField]="scopeField"
                [getItems]="getProjectScopes"
                valueField="localizedName"
                identifierField="number"
              />
            </mat-form-field>

            <mat-form-field matAutocompleteOrigin #projectTypeField="matAutocompleteOrigin" class="project-specifications__field">
              <mat-label>{{ "Projektart" | translate: "input-project-type" }}</mat-label>
              <app-base-select
                formControlName="projectType"
                [connectedFormField]="projectTypeField"
                [getItems]="getProjectTypes"
                valueField="localizedName"
                identifierField="number"
              />
            </mat-form-field>

            <mat-form-field matAutocompleteOrigin #categoryField="matAutocompleteOrigin" class="project-specifications__field">
              <mat-label>{{ "Projektkategorie" | translate: "input-project-category" }}</mat-label>
              <app-base-select
                formControlName="category"
                [connectedFormField]="categoryField"
                [getItems]="getProjectCategories"
                valueField="localizedName"
                identifierField="number"
              />
            </mat-form-field>

            <mat-form-field matAutocompleteOrigin #mainUsageField="matAutocompleteOrigin" class="project-specifications__field">
              <mat-label>{{ "Projektnutzung" | translate: "input-project-usage" }}</mat-label>
              <app-base-select
                formControlName="mainUsage"
                [connectedFormField]="mainUsageField"
                [getItems]="getProjectUsages"
                valueField="localizedName"
                identifierField="number"
              />
            </mat-form-field>

            <mat-form-field matAutocompleteOrigin #sideUsageField="matAutocompleteOrigin" class="project-specifications__field">
              <mat-label>{{ "Projektnebennutzung" | translate: "input-project-side-usage" }}</mat-label>
              <app-base-select
                formControlName="sideUsage"
                [connectedFormField]="sideUsageField"
                [getItems]="getProjectUsages"
                valueField="localizedName"
                identifierField="number"
              />
            </mat-form-field>
          </div>

          <div class="project-specifications__column">
            <h2 class="mat-body-large">
              {{ "Projektumfang" | translate: "paragraph-project-scope" }}
            </h2>

            <mat-form-field matAutocompleteOrigin #currencyField="matAutocompleteOrigin" class="project-specifications__field">
              <mat-label>{{ "Projektwährung" | translate:'input-project-currency' }}</mat-label>
              <app-base-select
                formControlName="currency"
                [connectedFormField]="currencyField"
                [getItems]="getProjectCurrencies"
                valueField="localizedName"
                identifierField="iso"
              />
            </mat-form-field>

            <mat-form-field class="project-specifications__field">
              <mat-label>{{ "Auftragsvolumen" | translate: "input-order-volume" }}</mat-label>
              <input
                type="text"
                matInput
                formControlName="orderVolume"
                mask="separator.2"
                thousandSeparator="."
                decimalMarker=","
																[triggerOnMaskChange]="false"
              />
              <span matSuffix class="project-specifications__suffix">
               {{ selectedCurrency()?.symbol ?? "" }}
              </span>
            </mat-form-field>

            <mat-form-field class="project-specifications__field">
              <mat-label>{{ "Gesamtleistung" | translate: "input-total-output" }}</mat-label>
              <input
                type="text"
                matInput
                formControlName="totalOutput"
                mask="separator.2"
                thousandSeparator="."
                decimalMarker=","
              />
              <span matSuffix class="project-specifications__suffix">
                {{ selectedCurrency()?.symbol ?? "" }}
              </span>
            </mat-form-field>

            <mat-form-field class="project-specifications__field">
              <mat-label>{{ "Brutto-Grundfläche (BGF) in m2" | translate: "input-total-space" }}</mat-label>
              <input type="text" matInput formControlName="grossArea" />
              <span matSuffix class="project-specifications__suffix">m²</span>
            </mat-form-field>

            <mat-form-field class="project-specifications__field">
              <mat-label>{{ "Brutto Rauminhalt (BRI) in m3" | translate: "input-total-volume" }}</mat-label>
              <input type="text" matInput formControlName="grossVolume" />
              <span matSuffix class="project-specifications__suffix">m³</span>
            </mat-form-field>
          </div>
        </div>

        <div class="project-specifications__special-features-header">
          <h2 class="mat-body-large">
            {{ "Besonderheiten" | translate: "paragraph-special-features" }}
          </h2>
          <mat-divider class="divider-outline-variant" />
        </div>

        <div class="project-specifications__special-features-group">
            <app-labeled-radiogroup
              formControlName="heritageProtected"
              [label]="'Denkmalgeschützt' | translate:'input-historic-monument' : 'feature/project-specifications'"
              [firstRadioLabel]="'Ja' | translate:'label-yes' : 'feature/project-specifications'"
              [secondRadioLabel]="'Nein' | translate:'label-no' : 'feature/project-specifications'"
            />
            <app-labeled-radiogroup
              formControlName="confidential"
              [label]="'Vertraulich' | translate:'input-confidential' : 'feature/project-specifications'"
              [firstRadioLabel]="'Ja' | translate:'label-yes' : 'feature/project-specifications'"
              [secondRadioLabel]="'Nein' | translate:'label-no' : 'feature/project-specifications'"
            />
        </div>
    </form>
  </div>

  <app-form-footer
    (save)="saveChanges()"
    (discard)="discardChanges()"
  />
</div>
